import { FaPencil } from "react-icons/fa6";
import { Button } from "react-bootstrap";
import { ITableRowData } from "@/manager/components/data-table/data-table";
import "./notes-expanded-view.scss";  

export interface INotesExpandedViewProps {
  data: ITableRowData[];
  handleEditNote(note: ITableRowData): void;
  isUserReadOnly?: boolean;
}

const NotesExpandedView = ({
  data,
  handleEditNote,
  isUserReadOnly = false
}: INotesExpandedViewProps) => {
  const formatDate = (dateString: string) => {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <div className="notesExpandedView">
      {data.map((note, index) => (
          <div key={note.id} className="notesExpandedView-item">
            <div className="notesExpandedView-table">
              <div className="notesExpandedView-left">
                <div className="notesExpandedView-row">
                  <div className="notesExpandedView-label">Title</div>
                  <div className="notesExpandedView-value">{note.title}</div>
                </div>
                <div className="notesExpandedView-row">
                  <div className="notesExpandedView-label">Created Date</div>
                  <div className="notesExpandedView-value">{formatDate(note.createdAt)}</div>
                </div>
                <div className="notesExpandedView-row">
                  <div className="notesExpandedView-label">Created By</div>
                  <div className="notesExpandedView-value">{note.createdByName}</div>
                </div>
                {!isUserReadOnly && (
                  <div className="notesExpandedView-actions">
                    {!isUserReadOnly &&
                    <Button
                      onClick={() => handleEditNote(note)}
                      title="Edit Note"
                      size="sm"
                    >
                      <FaPencil size={12}/>
                    </Button>
            }
                  </div>
                )}
              </div>
              <div className="notesExpandedView-right">
                <div className="notesExpandedView-contentLabel">Note Content</div>
                <div className="notesExpandedView-content">{note.content}</div>
              </div>
            </div>
            {index < data.length - 1 && <div className="notesExpandedView-divider" />}
          </div>
        ))}
    </div>
  );
};

export default NotesExpandedView;